/**
 * Responsável por .
 * @author: fabio.junior
 * Date: 10/12/13
 * Time: 15:11
 */


Greenmile.Marker = Greenmile.MarkerLocation || {};

Greenmile.Marker.Kind = {
    LOCATION: 'LOCATION',
    ORDER: 'ORDER',
    marker: 'marker'
};

Greenmile.Marker.GeneralFunctions = function () {

    var __map = null;

    this.setMap = function (map) {

        __map = map;

    };

    this.setModel = function (model) {
        this.model = model;
    };


    this.removeAllMarkers = function () {

        var layers,
            error;

        if (__map) {

            layers = __map._layers;

            for (var layer in layers) {

                if (Greenmile.Marker.Kind.hasOwnProperty(layers[layer].kind)) {
                    __map.removeLayer(layers[layer]);
                }

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                'Map is undefined on error remove all markers by id');
            error.console();

        }

    };


    this.createGenericMarker = function (id, params) {

        var marker = new L.marker(params.position, {
            icon: new L.icon({
                iconUrl: require('static/images/map/markers/generic_marker_blue.png'),
                iconSize: [15, 26],
                iconAnchor: [7.5, 26],
                popupAnchor: [-4, 32]
            })
        });

        marker.bindPopup(this.renderContentToPopup(this.model, marker), {
            closeOnClick: false,
            closeButton: false,
            offset: params.offset,
            minWidth: params.minWidth
        });

        marker.id = id;
        marker.kind = params.kind;

        return marker;

    };

};

